import React from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, IconButton, MoonIcon, SunIcon } from "@KristianIV/common-ui";
import { ApplicationState } from "../reducers";
import { useAppDispatch } from "../storeHooks";
import { setUserAction, setUserDataAction } from "../loginReducer";
import Brand from "./Brand";
import { useTheme } from "./theme";
import styles from "./AppNav.module.css";

/**
 * Top navigation for pages built on common-ui. Same anatomy as core-ui's Navigation:
 * 64px, logo on the left, theme toggle on the right, plus the admin's sign-out.
 */
const AppNav = () => {
  const { theme, toggleTheme } = useTheme();
  const dispatch = useAppDispatch();
  const signedIn = useSelector(
    (state: ApplicationState) => !!(state.login.user && state.login.jwtToken && state.login.userData)
  );

  const signOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch(setUserDataAction(undefined));
        dispatch(setUserAction(undefined));
      });
  };

  return (
    <nav className={styles.nav}>
      <Link to="/" className={styles.home}>
        <Brand />
      </Link>
      <div className={styles.right}>
        <IconButton
          icon={theme === "dark" ? <SunIcon size={20} /> : <MoonIcon size={20} />}
          tooltip={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
          onClick={toggleTheme}
        />
        {signedIn && <Button onClick={signOut}>Sign out</Button>}
      </div>
    </nav>
  );
};

export default AppNav;
